"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12.5 4a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0zm7.5 8.5a.5.5 0 0 0 0-1h-4a.5.5 0 0 0 0 1zm-8 3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5m-4-3a.5.5 0 0 0 0-1H4a.5.5 0 0 0 0 1zm.854-3.647a.5.5 0 0 1-.707 0l-1.5-1.5a.5.5 0 0 1 .706-.707l1.5 1.5a.5.5 0 0 1 0 .707m6.293-.706a.5.5 0 0 0 .708.707l1.5-1.5a.5.5 0 1 0-.708-.707zm2.208 9.207a.5.5 0 0 1-.707 0l-1.5-1.5a.5.5 0 0 1 .707-.707l1.5 1.5a.5.5 0 0 1 0 .707m-10.708-.707a.5.5 0 0 0 .708.707l1.5-1.5a.5.5 0 0 0-.708-.707z"
}), 'WhatsNew'); //# sourceMappingURL=index.js.map
